/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import SampleCheck from '../assets/sample-check.png';
import { memo } from 'react';
import Styles from '../css/OneTimePaymentPage.module.css';
import OneTimePaymentForm from '../components/forms/OneTimePaymentForm';
import { OneTimePaymentProvider } from '../contexts/OneTimePaymentContext';
import { useRootContext } from '../contexts/RootContext';
import OneTimePaymentTable from '../components/forms/OneTimePaymentTable';

const OneTimePaymentPage = () => {
  const rootContext = useRootContext();

  return (
    <OneTimePaymentProvider>
      <OneTimePaymentTable />
      <div className={Styles.page}>
        <OneTimePaymentForm />
        <p className={Styles.noteText}>
          The withdrawal from your bank account will generally occur within two business days, but the exact timing is
          dependent on your bank's processing schedule.
        </p>
        <div ref={rootContext.scrollRef} className={Styles.sampleCheck}>
          <h2 className={Styles.checkLabel}>Sample Check</h2>
          <img src={SampleCheck} alt='Sample Check' className={Styles.checkImage} />
        </div>
      </div>
    </OneTimePaymentProvider>
  );
};

export default memo(OneTimePaymentPage);
